import { pick } from 'lodash-es'

import { determinePreviewCardLocationFields } from './utils'

export const prepareValuesForPreview = (eventType, formValues) => {
  const notDeletedLocationConfigurations = (formValues.locationConfigurations || []).filter(({ _destroy }) => !_destroy)

  return formValues.locationConfigurations !== undefined
    ? {
      hide_location: notDeletedLocationConfigurations[0]?.hide_location || false,
      location_configurations: notDeletedLocationConfigurations,
      ...determinePreviewCardLocationFields(formValues)
    }
    : pick(eventType, ['hide_location', 'location_configurations', 'location_types_count', 'location_type'])
}
